import { Component, input } from '@angular/core';

@Component({
  selector: 'app-report-text',
  templateUrl: './report-text.component.html',
  styleUrl: './report-text.component.scss',
})
export class ReportTextComponent {
  public readonly textCenter = input<boolean>();
  public readonly textRight = input<boolean>();
}
